import React, { useEffect, useState } from 'react';
import styles from './personalizeInfoOverlay.module.scss';
import { ILocalization } from '../types';
import CrossRing from '../icons/crossRing';
import classNames from 'classnames';


interface IPersonalizeInfoOverlyProps {
    localization: ILocalization;
    confirmRegistrationHintIsVisible: boolean;
    closeOverlay: () => void;
}

export const PersonalizeInfoOverlay = (props: IPersonalizeInfoOverlyProps) => {
    const localization = props.localization;
    const [confirmText, setConfirmText] = useState('');

    useEffect(() => {
        setConfirmText(
            (localization.personalizationRegistrationConfirmHint || '')
                .replace(/\{0\}/, localization.supportPhoneNumber || '')
        );
    }, [localization]);

    return <div className={classNames(styles.po_info_container,
        { [styles.show_po]: props.confirmRegistrationHintIsVisible })}>
        <div className={styles.personalize_overlay}>
            <div className={styles.po_header}>
                <div className={styles.h_title}>{localization.note}</div>
                <div className={styles.h_cross_icon} onClick={props.closeOverlay} data-testid='pdp-mo-close'
                    data-semantic-id='pdp-mo-close'>
                    <CrossRing />
                </div>
            </div>
            <div className={styles.po_body} dangerouslySetInnerHTML={{
                __html: confirmText
            }}>
            </div>
        </div>
    </div>
}

